import React from "react";
import { useNewsletterContext } from "scmp-sdk/components/newsletter/newsletter-widget/contexts";

import { Heading, Summary } from "./styles";

export const Article20ThemeSummary: React.FunctionComponent = () => {
  const { newsletterItemForDisplay } = useNewsletterContext();

  return (
    <>
      <Heading>NEWSLETTER</Heading>
      <Summary>{newsletterItemForDisplay?.summary?.text}</Summary>
    </>
  );
};

Article20ThemeSummary.displayName = "Article20ThemeSummary";
